
export const apiUrl = "https://api.kelvin.ziz.co.ke/api"
export const socketsApiUrl = "wss://api.kelvin.ziz.co.ke"
